import { FC } from 'react';
import styled from '@emotion/styled';
import { Text } from 'components/_temp_ui_common/theme/Text';

import { Modal, ModalContent } from '../ReferralExclusionModal';

const StyledModalContent = styled(ModalContent)`
  position: relative;
  background: white;
  padding: 32px;
  border-radius: 24px;
  max-width: 700px;
  width: 98%;

  @media (max-width: 768px) {
    width: calc(100% - 16px);
    margin: auto 8px;
    padding: 24px;
    max-height: 90vh;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    position: relative;
    top: 50%;
    transform: translateY(-50%);
  }
`;

interface NpWhatsThisModalProps {
  setShowModal: (show: boolean) => void;
}

const NpWhatsThisModal: FC<NpWhatsThisModalProps> = ({ setShowModal }) => {
  return (
    <Modal onClick={() => setShowModal(false)}>
      <StyledModalContent onClick={e => e.stopPropagation()}>
        <Text variant="h4" className="text-center mb-4">
          What is a Clinical Intake?
        </Text>
        <Text variant="body-5" className="mt-2">
          The first step is a Clinical Intake which is a thorough interview with
          a Bend Provider to explore areas such as cognitive functioning,
          emotional and developmental history, educational background, and daily
          challenges. This helps ensure the evaluation focuses on relevant
          information for an accurate diagnosis and effective treatment plan.
        </Text>
      </StyledModalContent>
    </Modal>
  );
};

export default NpWhatsThisModal;
